import React, { createContext, useState, useContext } from "react";

interface GeneratePDFContextType {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  element: any;
  setElement: (element: any) => void;  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;
  modelId: any;
  setModelId: (modelId: any) => void;
}

export const GeneratePDFContext = createContext<GeneratePDFContextType>({  
  showModal: false,
  setShowModal: () => {},
  element: null,
  setElement: () => {},
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  modelId: null,
  setModelId: () => {},
});

interface GeneratePDFProviderProps {
  children: React.ReactNode;
}

export const GeneratePDFProvider: React.FC<GeneratePDFProviderProps> = ({
  children,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [element, setElement] = useState<any>(null);
  const [backendFormErrors, setBackendFormErrors] = useState<any>({});
  const [modelId, setModelId] = useState<any>(null);


  const value = {
    showModal,
    setShowModal,
    element,
    setElement,
    backendFormErrors,
    setBackendFormErrors,
    modelId,
    setModelId,
  };
  return (
    <GeneratePDFContext.Provider value={value}>
      {children}
    </GeneratePDFContext.Provider>
  );
};
